import ReviewProductCreate, {
  ReviewProductCreateProps,
} from '@entities/Review/ui/product/create'
import styles from '@entities/Review/ui/product/styles.module.scss'

import { useModalStore } from '@features/modal'




export default function useProductReviewCreate (
  props: ReviewProductCreateProps,
) {
  const { openModal, closeModal } = useModalStore()

  const openProductReviewModal = () => {
    openModal('reviewCreate', <ReviewProductCreate data={props.data} />, {
      title: 'Отзыв о товаре',
      classes: {
        content: styles['modal-content-create'],
      },
    })
  }

  const closeProductReviewModal = () => {
    closeModal('reviewCreate')
  }

  return {
    openProductReviewModal,
    closeProductReviewModal,
  }
}
